import { render, staticRenderFns } from "./role.vue?vue&type=template&id=b1fc4b62&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&id=b1fc4b62&scoped=true&lang=scss&"
import style1 from "./role.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fc4b62",
  null
  
)

export default component.exports